module.exports = __webpack_public_path__ + "images/emoji/dress.93b9d7cdafad4eec96dd.png";